import React, { useState } from "react";

const C = {
  bg:     "#F8F6F1",
  forest: "#2D5A3D",
  dark:   "#1C3A28",
  accent: "#C4622D",
  text:   "#1C1C1E",
  muted:  "#8A8A8E",
  border: "#D3D1C7",
};

const getPlans = (t) => [
  {
    id: "gratuit",
    label: t.gratuit || "Gratuit",
    price: "0 €",
    period: "",
    priceAnnual: null,
    recommended: false,
    color: C.muted,
    bg: "white",
    features: [
      t.feat_1Vehicule        || "1 véhicule",
      t.feat_checklistEntretien || "Checklist entretien",
      t.feat_documents        || "Documents",
      t.feat_rappels          || "Rappels",
      t.feat_boutonSecours    || "Bouton secours",
      t.feat_certificatQR     || "Certificat QR code",
      { icon: "☁️", text: t.feat_meteoJour || "Météo du jour" },
    ],
  },
  {
    id: "premium",
    label: t.premium || "Premium",
    price: "2,99 €",
    period: t.parMois || "/mois",
    priceAnnual: `19,99 € ${t.parAn || "/an"}`,
    recommended: true,
    color: C.forest,
    bg: "#EAF5EE",
    features: [
      t.feat_toutGratuit      || "Tout le gratuit +",
      t.feat_multilingue      || "Multilingue FR/EN (auto)",
      t.feat_diagnosticIA     || "Diagnostic IA des voyants",
      t.feat_exportPDF        || "Export PDF avancé",
      t.feat_depenses3mois    || "Dépenses & Km 3 mois",
      t.feat_stats3mois       || "Statistiques 3 mois",
      t.feat_historique3mois  || "Historique 3 mois",
      { icon: "☁️", text: t.feat_meteo3jours || "Prévisions météo 3 jours" },
    ],
  },
  {
    id: "ultra",
    label: t.ultra || "Ultra",
    price: "4,99 €",
    period: t.parMois || "/mois",
    priceAnnual: `34,99 € ${t.parAn || "/an"}`,
    recommended: false,
    color: C.accent,
    bg: "#FDF2EC",
    features: [
      t.feat_toutPremium        || "Tout le premium +",
      t.feat_multilingue        || "Multilingue FR/EN (auto)",
      t.feat_pdfOCR             || "PDF avancé + Scanner OCR",
      t.feat_notifications      || "Notifications push",
      t.feat_pwa                || "PWA installable",
      t.feat_depensesIllimite   || "Dépenses & Km illimité",
      t.feat_stats12mois        || "Statistiques 12 mois",
      t.feat_historiqueIllimite || "Historique illimité",
      t.feat_obd2               || "Diagnostic OBD2 🔌",
      t.feat_diagIA             || "Diagnostic voyants IA 🔍",
      { icon: "☁️", text: t.feat_meteo7jours || "Prévisions météo 7 jours" },
    ],
  },
];

export default function PremiumScreen({ onClose, t = {} }) {
  const [billing, setBilling] = useState("monthly");
  const PLANS = getPlans(t);

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 800,
      background: "rgba(0,0,0,0.65)",
      display: "flex", alignItems: "flex-end", justifyContent: "center",
    }} onClick={onClose}>
      <div
        style={{
          background: C.bg, borderRadius: "24px 24px 0 0",
          width: "100%", maxWidth: 430, maxHeight: "92vh",
          overflowY: "auto", paddingBottom: 36,
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          background: C.forest, borderRadius: "24px 24px 0 0",
          padding: "22px 20px 18px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
        }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 900, color: "#F8F6F1" }}>{t.plansCheckVan || "✨ Plans CheckVan"}</div>
            <div style={{ fontSize: 12, color: "rgba(248,246,241,0.65)", marginTop: 2 }}>
              {t.choisissezFormule || "Choisissez votre formule"}
            </div>
          </div>
          <button onClick={onClose} style={{
            width: 34, height: 34, borderRadius: "50%",
            background: "rgba(255,255,255,0.15)", border: "none",
            color: "#F8F6F1", fontSize: 18, fontWeight: 700,
            cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
          }}>✕</button>
        </div>

        {/* Toggle mensuel / annuel */}
        <div style={{ padding: "16px 20px 4px", display: "flex", justifyContent: "center" }}>
          <div style={{
            display: "flex", background: "white", borderRadius: 12,
            border: `1px solid ${C.border}`, overflow: "hidden",
          }}>
            {[
              { id: "monthly", label: t.mensuel || "Mensuel" },
              { id: "annual",  label: t.annuel   || "Annuel −30%" },
            ].map(opt => (
              <button
                key={opt.id}
                onClick={() => setBilling(opt.id)}
                style={{
                  padding: "8px 18px", border: "none", cursor: "pointer",
                  fontFamily: "inherit", fontSize: 12, fontWeight: 800,
                  background: billing === opt.id ? C.forest : "transparent",
                  color: billing === opt.id ? "#F8F6F1" : C.muted,
                  transition: "background 0.2s",
                }}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        {/* Cards */}
        <div style={{ padding: "16px 16px 0" }}>
          {PLANS.map(plan => (
            <div key={plan.id} style={{
              background: plan.bg,
              borderRadius: 16, marginBottom: 12,
              border: plan.recommended
                ? `2px solid ${C.forest}`
                : `1px solid ${C.border}`,
              overflow: "hidden",
              boxShadow: plan.recommended ? "0 4px 20px rgba(45,90,61,0.15)" : "none",
            }}>
              {/* Badge recommandé */}
              {plan.recommended && (
                <div style={{
                  background: C.forest, textAlign: "center",
                  padding: "4px 0", fontSize: 11, fontWeight: 800,
                  color: "#F8F6F1", letterSpacing: 1,
                }}>
                  {t.recommande || "★ RECOMMANDÉ"}
                </div>
              )}

              <div style={{ padding: "16px 18px" }}>
                {/* Titre + prix */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
                  <div>
                    <div style={{ fontSize: 16, fontWeight: 900, color: plan.color }}>
                      {plan.label}
                    </div>
                    {plan.priceAnnual && (
                      <div style={{ fontSize: 11, color: C.muted, marginTop: 2 }}>
                        {billing === "annual" ? plan.priceAnnual : `${t.ou || "ou"} ${plan.priceAnnual}`}
                      </div>
                    )}
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <span style={{ fontSize: 22, fontWeight: 900, color: plan.color }}>
                      {billing === "annual" && plan.priceAnnual
                        ? plan.priceAnnual.split(" ")[0]
                        : plan.price}
                    </span>
                    <span style={{ fontSize: 12, color: C.muted, fontWeight: 600 }}>
                      {billing === "annual" && plan.priceAnnual ? ` ${t.parAn || "/an"}` : plan.period}
                    </span>
                  </div>
                </div>

                {/* Features */}
                <div style={{ marginBottom: 14 }}>
                  {plan.features.map(f => {
                    const isObj = typeof f === "object";
                    const key   = isObj ? f.text : f;
                    const icon  = isObj ? f.icon : "✓";
                    const label = isObj ? f.text : f;
                    return (
                      <div key={key} style={{
                        display: "flex", alignItems: "center", gap: 8,
                        marginBottom: 6,
                      }}>
                        <span style={{
                          fontSize: isObj ? 14 : 12,
                          color: isObj ? undefined : plan.color,
                          flexShrink: 0,
                        }}>{icon}</span>
                        <span style={{ fontSize: 13, color: C.text }}>{label}</span>
                      </div>
                    );
                  })}
                </div>

                {/* Bouton */}
                <button style={{
                  width: "100%", padding: "11px 0",
                  background: plan.id === "gratuit" ? "transparent" : plan.color,
                  border: plan.id === "gratuit" ? `1.5px solid ${C.border}` : "none",
                  borderRadius: 10,
                  color: plan.id === "gratuit" ? C.muted : "white",
                  fontSize: 13, fontWeight: 800,
                  cursor: plan.id === "gratuit" ? "default" : "pointer",
                  fontFamily: "inherit",
                }}>
                  {plan.id === "gratuit"
                    ? (t.planActuel    || "Plan actuel")
                    : plan.id === "premium"
                      ? (t.choisirPremium || "Choisir Premium")
                      : (t.choisirUltra   || "Choisir Ultra")}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Fermer */}
        <div style={{ padding: "8px 16px 0" }}>
          <button onClick={onClose} style={{
            width: "100%", padding: "13px 0",
            background: "white", border: `1.5px solid ${C.border}`,
            borderRadius: 12, color: C.muted,
            fontSize: 14, fontWeight: 700,
            cursor: "pointer", fontFamily: "inherit",
          }}>
            {t.fermer || "Fermer"}
          </button>
        </div>
      </div>
    </div>
  );
}
